module.exports = __webpack_public_path__ + "static/img/huwai.7dbb283.png";


//////////////////
// WEBPACK FOOTER
// ./static/huwai.png
// module id = JI9u
// module chunks = 1